import React, { MouseEvent } from 'react';
import { Grid, Typography } from '@mui/material';
import { TextField, Link } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import LoadingButton from '@mui/lab/LoadingButton';
import { useState } from 'react';
import styles from './EventSearch.module.css';

interface IProps {
  searchEvents: Function;
  loading: boolean;
  error: boolean;
}

function EventSearchField({ searchEvents, loading, error }: IProps) {
  const [eventId, setEventId] = useState('');

  const clearSearchField = (event: MouseEvent) => {
    event.preventDefault();
    setEventId('');
  };

  const handleSubmit = (event: React.SyntheticEvent) => {
    event.preventDefault();
    searchEvents(eventId);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid
        container
        alignItems='center'
        justifyContent='flex-start'
        spacing={2}
      >
        <Grid item sm={7} xs={12}>
          <TextField
            size='small'
            fullWidth
            value={eventId}
            onChange={(e) => setEventId(e.target.value.trim().toUpperCase())}
            placeholder='Event ID'
            required
            disabled={loading}
            error={error}
            label='Event ID'
          />
        </Grid>

        <Grid item md={3} sm={4} xs={12}>
          <LoadingButton
            fullWidth
            variant='contained'
            className={styles.searchButton}
            endIcon={<SearchIcon />}
            loading={loading}
            loadingPosition='end'
            type='submit'
          >
            Search Events
          </LoadingButton>
        </Grid>
        <Grid item container xs={12} sm='auto'>
          <Link href={''} onClick={clearSearchField}>
            <Typography variant='subtitle2'>Reset Search</Typography>
          </Link>
        </Grid>
      </Grid>
    </form>
  );
}

export default EventSearchField;
